// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"cb2d7ae1","605":"a3769d3a","725":"22cb19ed"}[chunkId] + ".chunk.js";
};